import { createElement } from 'react';

import { resolveModuleIcon } from '../lib/module-icons';

interface ModuleIconProps {
  /** Nombre del icono lucide guardado en la base de datos (`modulos.icono_web`). */
  name: string | null | undefined;
  className?: string;
}

/**
 * Renderiza el icono de un módulo o categoría a partir del nombre almacenado
 * en la base de datos. Si el nombre no está registrado, cae en un icono por
 * defecto (ver `lib/module-icons.ts`).
 */
export function ModuleIcon({ name, className }: ModuleIconProps) {
  return createElement(resolveModuleIcon(name), { className, 'aria-hidden': true });
}
